import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=828f9e82&scoped=true"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=828f9e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f9e82",
  null
  
)

export default component.exports